exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".refresh-button-container{display:flex;justify-content:center;align-items:center;height:20px}.refresh-icon{background:none;border:none;cursor:pointer;font-size:24px;transition:transform .3s ease-in-out;color:#525252}.dashboardcontainer .refresh-icon{color:#525252}.spin{animation:spin 1s linear infinite}@keyframes spin{from{transform:rotate(0deg)}to{transform:rotate(360deg)}}", ""]);

// exports
